var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"create-mailing-template-page"},[_c('BackTitle',{staticClass:"mb-40",attrs:{"confirm-click":""},on:{"click":_vm.goBack}},[_vm._v(" Create mailing template ")]),_c('MailingTemplateForm',{attrs:{"value":_vm.mailingTemplate,"is-submitting":_vm.isSubmitting},on:{"submit":_vm.handleSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }